<script lang="ts">
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";
import {MediaGalleryFilterType} from "@src/Resources/epim/Templates/MediaGallery/types/MediaGalleryFilterType";
import {GlobalFilterChangeEvent} from "@global/global-elements/global-filter/GlobalFilterType";
import GlobalFilterSelected from "@global/global-elements/global-filter-selected/global-filter-selected.vue";

export default defineComponent({
    name: "MediaGallerySelectedFilters",
    components: {GlobalFilterSelected, GlobalButton},
    computed: {
        ...mapGetters({
            selectedFilters: 'getSelectedFilters',
            keyword: 'getKeyword'
        }),
        selectedOptions() {
            const options: {filterName: string, optionName: string, optionTitle: string}[] = []
            this.selectedFilters.forEach((filter: MediaGalleryFilterType) => {
                filter.options.forEach(option => {
                    if (option.selected) {
                        options.push({
                            filterName: filter.name,
                            optionName: option.key,
                            optionTitle: option.title
                        })
                    }
                })
            })

            return options
        },
        showComponent() {
            return this.selectedOptions.length > 0 || this.keyword
        }
    },
    methods: {
        handleFilterRemove(event: GlobalFilterChangeEvent) {
            this.$store.dispatch("updateFilter", event)
        },
        resetKeyword() {
            if (this.keyword) {
                this.$store.dispatch("setKeyword", "")
            }
        },
        reset() {
            this.resetKeyword()
            this.$store.dispatch("resetFilters")
        }
    }
})
</script>

<template>
    <div class="media-gallery-selected-filters" v-if="showComponent">
        <global-filter-selected v-if="keyword" @click="resetKeyword">"<i>{{keyword}}</i>"</global-filter-selected>
        <template v-for="filter in selectedOptions">
            <global-filter-selected @click="handleFilterRemove({filterName: filter.filterName, optionName: filter.optionName})">{{filter.optionTitle}}</global-filter-selected>
        </template>
        <global-button @click="reset" icon="close" theme="ghost">{{$t('mediaGallery.filter.reset')}}</global-button>
    </div>
</template>

